module.exports = __webpack_public_path__ + "img/car-side.86fbadd2.svg";